import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import {
    Category,
    Results,
    Sizes,
    UsageSubscription,
    UsageType,
    User
} from 'src/app/shared/classes/app.models';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';
import { SearchService } from 'src/app/shared/services/search.service';
import { AiEditSource } from 'src/app/shared/components/ai-edit-modal/ai-edit-modal.component';

declare var window: any;
declare let $: any;

@Component({
    selector: 'media-detail',
    templateUrl: './media-detail.component.html',
    styleUrls: ['./media-detail.component.scss']
})
export class MediaDetailComponent implements OnInit, OnDestroy {

    public disableBtn = false;
    public exist = true;
    public isfetch = false;
    public usage = false;
    public showZoom = false;
    public zoomLoading = false;

    public id!: string;
    public collection!: string;
    public categoryId!: number;
    public btn = 0;

    public mediaType: 'images' | 'videos' = 'images';
    public isVideoPlaying = false;
    public code: string = '';
    public image: any;
    public zoomImage: any;
    public videoSrc: any;
    public images!: Results;
    public wish!: Results;
    public cartProduct: any;

    public usageType: any;
    public usageSelected!: UsageType;

    public categories: Category[] = [];
    public collectionSize!: Category;
    public relatedProducts: Results[] = [];
    public currentUser!: User & { customers_type?: number; isAdmin?: number };

    public editorial: string[] = ['210', '23', '208', '13', '132', '162', '168', '169', '170'];
    public partner = ['93', '210', '179', '130', '211', '172', '160', '124', '161'];

    private routeSub!: Subscription;

    constructor(
        public appService: ExclusiveService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public authService: AuthenticationService,
        public toastService: ToastrService,
        public searchService: SearchService
    ) {
        this.authService.currentUser.subscribe(x => this.currentUser = x as any);
    }

    ngOnInit() {
        const param = this.router.parseUrl(this.router.url);
        this.categoryId = param.queryParams.category === 'editorial' ? 3 : 1;
        this.btn = 0;

        this.routeSub = this.activatedRoute.paramMap.subscribe(params => {
            this.id = params.get('id') || '';
            this.collection = params.get('collection') || '';
            const type = (params.get('type') || 'images').toLowerCase();
            this.mediaType = type === 'videos' ? 'videos' : 'images';
            this.exist = true;
            this.isfetch = false;
            this.relatedProducts = [];
            this.image = null;
            this.zoomImage = null;
            this.videoSrc = null;
            this.getCategories();
            if (this.mediaType === 'videos') {
                this.getVideoById();
            } else {
                this.getImageById();
            }
        });

        this.searchService.setCategory(this.categoryId);
    }

    ngOnDestroy() {
        if (this.routeSub) {
            this.routeSub.unsubscribe();
        }
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    }

    private get adminFlag(): number {
        return (this.currentUser?.isAdmin as any)
            ?? 0;
    }

    public getCategories() {
        if (!this.appService.Data.categories || this.appService.Data.categories.length === 0) {
            this.appService.getCategories().subscribe(data => {
                this.categories = data || [];
                this.appService.Data.categories = this.categories;
            });
        } else {
            this.categories = this.appService.Data.categories;
        }
    }

    public getCollectionName(collectionId: any): string {
        const list = this.categories?.length ? this.categories : this.appService.Data.categories;
        const cat = (list || []).filter(c => c && (c.id + '') === (collectionId + ''))[0];
        return cat ? cat.name : '';
    }

    public getImageById() {
        this.appService.getImageById(this.id, this.collection, this.adminFlag).subscribe(data => {
            if (!data || (data.error && data.error !== '')) {
                this.exist = false;
                return;
            }

            this.images = data;
            this.image = data.thumbnail;
            this.zoomImage = data.preview;

            if (this.editorial.indexOf(this.collection) > -1) {
                this.usage = true;
            } else if (this.collection === '179') {
                this.usage = !!data.iseditorial;
            }

            if (this.partner.filter(item => item == this.collection).length > 0) {
                this.code = this.images.filename.substr(0, 4);
            } else {
                this.code = this.images.author;
            }

            const lastSize = data.sizes && data.sizes.length
                ? data.sizes[data.sizes.length - 1].name
                : '';

            this.cartProduct = {
                id: data.id,
                filename: data.filename,
                thumbnail: data.thumbnail,
                license: data.license,
                collection: data.collection,
                size: lastSize,
                price: 0,
                type: 'Image',
                caption: data.caption,
                category: this.categoryId === 1 ? 'creative' : 'editorial'
            };

            this.wish = Object.assign({}, this.images);
            if (this.collection === '93') {
                this.wish.id = (this.images.filename || '').replace('ALAM_', '');
                this.wish.filename = this.images.id + '';
            }

            this.getSubscriptionDetail();
            this.getRelatedProducts();
        }, () => {
            this.exist = false;
        });
    }

    public getVideoById() {
        this.appService.getVideoById(this.id, this.collection).subscribe(data => {
            if (!data || (data.error && data.error !== '')) {
                this.exist = false;
                return;
            }

            this.images = data;
            this.image = data.thumbnail;
            this.videoSrc = data.preview;
            this.zoomImage = data.preview;

            if (this.editorial.indexOf(this.collection) > -1) {
                this.usage = true;
            } else if (this.collection === '179') {
                this.usage = !!data.iseditorial;
            }

            if (this.partner.filter(item => item == this.collection).length > 0) {
                this.code = this.images.filename.substr(0, 4);
            } else {
                this.code = this.images.author;
            }


            const lastSize = data.sizes && data.sizes.length
                ? data.sizes[data.sizes.length - 1].name
                : '';
            const lastPrice = data.sizes && data.sizes.length
                ? (data.sizes[data.sizes.length - 1] as any).price || 0
                : 0;

            this.cartProduct = {
                id: data.id,
                filename: data.filename,
                thumbnail: data.thumbnail,
                license: data.license,
                collection: data.collection,
                size: lastSize,
                price: lastPrice,
                type: 'Video',
                caption: data.caption,
                category: this.categoryId === 1 ? 'creative' : 'editorial'
            };

            this.wish = Object.assign({}, this.images);

            this.getVideoSubscriptionDetail();
            this.getRelatedProducts();
        }, () => {
            this.exist = false;
        });
    }

    public getSubscriptionDetail() {
        if (!this.currentUser) {
            return;
        }
        const category = this.categoryId === 1 ? 'creative' : 'editorial';
        this.appService.getSubscriptionDetail(
            category,
            this.images.collection,
            this.images.id,
            this.images.license,
            this.adminFlag
        ).subscribe((data: any) => {
            this.usageType = data;
            if (this.usageType?.usage) {
                this.usageType.usage = (this.usageType.usage || []).filter((item: any) => item.subscription > 0);
            }
            if (this.images.sizes?.length === 1 && this.images.sizes[0].name === 'Vector') {
                this.usageType.comp_status = 0;
            }
            if (this.images.sizes?.length) {
                this.cartProduct.size = this.images.sizes[this.images.sizes.length - 1].name;
            }
            if (this.usageType?.usage?.length) {
                this.changeUsageType(this.usageType.usage[0]);
            }
        });
    }

    public getVideoSubscriptionDetail() {
        if (!this.currentUser) {
            return;
        }
        const category = this.categoryId === 1 ? 'creative' : 'editorial';
        this.appService.getDownloadVideoDetail(
            category,
            this.images.collection,
            this.images.id,
            this.images.license,
            this.adminFlag
        ).subscribe((data: any) => {
            this.usageType = data;

            if (this.usageType?.usage) {
                this.usageType.usage = (this.usageType.usage || []).filter((item: any) => item.subscription > 0);
            }
            if (this.images.sizes?.length) {
                this.cartProduct.size = this.images.sizes[this.images.sizes.length - 1].name;
            }
            if (this.usageType?.usage?.length) {
                this.changeUsageType(this.usageType.usage[0]);
            }
        });
    }

    public changeUsageType(usage: UsageType) {

        if (!this.usageType?.usage) {
            return;
        }
        this.usageSelected = this.usageType.usage.filter((item: any) => item.name === usage.name)[0];
        if (this.usageSelected) {
            this.cartProduct.price = this.usageSelected.price;
            this.cartProduct.usage_type = this.usageSelected.name;
        } else {
            this.cartProduct.price = 0;
            this.cartProduct.usage_type = '';
        }
        this.refreshActionState();
    }

    public changeSize(size: Sizes) {
        this.cartProduct.size = size.name;
        this.refreshActionState();
    }

    private refreshActionState() {
        if (!this.usageSelected || !this.usageSelected.size) {
            this.btn = 0;
            return;
        }
        const size: any = this.usageSelected.size.filter((item: any) => item.name === this.cartProduct.size)[0];
        if (!size) {
            this.btn = 0;
            return;
        }
        
        // console.log(this.usageSelected.subscription, size);
        // this.btn = size.is_downloaded
        //     ? 2
        //     : (this.usageSelected.subscription > 0 && size.size_available ? 1 : 0);
        this.btn = size.is_downloaded
            ? 2
            : (this.usageSelected.subscription > 0 ? 1 : 0);

    }

    public download(isSubscription: boolean) {

                if (this.disableBtn) {
                    return;
                }
                this.disableBtn = true;
                const downloadCall = this.mediaType === 'videos'
                    ? this.appService.downloadVideo({ ...this.cartProduct, usage_type: this.usageSelected.name }, isSubscription, this.adminFlag)
                    : this.appService.downloadImage(this.cartProduct, isSubscription, this.adminFlag);

                downloadCall.subscribe((data: any) => {
                    this.disableBtn = false;
                    if (!data || !data[0] || !data[0].download_link) {
                        /*
                         * The backend says WHY when it knows — out of credits, or a
                         * plan that does not cover this collection or size. Those are
                         * things the customer can act on, and "please try again" is
                         * advice to repeat something that will fail identically.
                         * The generic line stays for the cases it cannot explain.
                         */
                        if(data[0]?.credit_issue){
                            this.toastService.error(data[0]?.credit_issue);
                        }else{
                            this.toastService.error(
                            (data && data[0] && data[0].message)
                                ? data[0].message
                                : 'Unable to start download. Please try again.'
                            );
                        }
                        return;
                    }

                    if (data && data[0] && data[0].download_link) {
                    const url = data[0].download_link;
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = this.images.id + '';
                    a.target = '_blank';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    this.btn = 2;
                    }

                    const usageItem: any = this.usageType.usage.filter((item: any) => item.name === this.usageSelected.name)[0];
                    if (usageItem) {
                        usageItem.subscription = data[0].subscription;
                        usageItem.price = data[0].price;
                        const sizeItem: any = (usageItem.size || []).filter((s: any) => s.name === this.cartProduct.size)[0];
                        if (sizeItem) {
                            sizeItem.download_link = data[0].download_link;
                        }
                        this.usageSelected = usageItem;
                    }

                }, () => {
                    this.disableBtn = false;
                    this.toastService.error('Download failed. Please try again.');
                });
    }

    public addToDownload() {
        this.appService.addToDownload(this.cartProduct, this.adminFlag)
            .subscribe((res: any) => {
                if (res && res.data) {
                    this.toastService.success('Image added to download list');
                } else {
                    this.toastService.error('Problem in downloading image. Contact sales to resolve.');
                }
            });
    }

    public reDownloadImage() {
        this.appService.reDownloadImageById(this.cartProduct, this.adminFlag)
            .subscribe((res: any) => {
                if (res && res.data) {
                    window.open(res.data, '_blank');
                } else {
                    this.toastService.error('Problem in downloading image. Contact sales to resolve.');
                }
            });
    }

    public compDownload() {
        const url = this.images?.thumbnail;
        if (!url) {
            this.toastService.error('Comp download is not available right now.');
            return;
        }

        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = this.images.id + '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(() => {
                this.toastService.error('Comp download failed. Please try again.');
            });
    }

    public toggleVideoPlay(video: HTMLVideoElement) {
        if (!video) {
            return;
        }
        if (video.paused || video.ended) {
            video.play().catch(() => { });
        } else {
            video.pause();
        }
    }

    public openZoomViewer() {
        if (!this.zoomImage && !this.image && !this.videoSrc) {
            return;
        }
        this.zoomImage = this.images?.preview || this.zoomImage;
        if (this.mediaType === 'videos') {
            this.videoSrc = this.images?.preview || this.videoSrc;
        } else {
            this.zoomLoading = true;
        }
        this.showZoom = true;
        if (typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    }

    public closeZoomViewer() {
        this.showZoom = false;
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    }

    public openPreviewInNewTab() {
        const target = this.zoomImage || this.image;
        if (target) {
            window.open(target, '_blank');
        }
    }

    public openRelatedZoom(product: any) {
        const target = product?.preview || product?.thumbnail;
        if (!target) {
            return;
        }
        this.zoomImage = target;
        if (this.mediaType === 'videos') {
            this.videoSrc = product?.preview || target;
        } else {
            this.zoomLoading = true;
        }
        this.showZoom = true;
        if (typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    }

    @HostListener('document:keydown.escape')
    onEscape() {
        if (this.showZoom) {
            this.closeZoomViewer();
        }
    }

    /** Similar media shown: 12 at least where the library has them, 18 at most. Same rule as products/media-detail. */
    private static readonly SIMILAR_MIN = 12;
    private static readonly SIMILAR_MAX = 18;

    public getRelatedProducts() {
        this.relatedProducts = [];

        this.searchSimilar(this.images.caption, rows => {
            this.setRelated(rows);
            this.isfetch = true;
            $('.preloader').stop(true, true).fadeOut('slow');
            this.topUpSimilar();
        }, () => {
            this.isfetch = true;
            $('.preloader').stop(true, true).fadeOut('slow');
        });
    }

    private searchSimilar(text: string, done: (rows: any[]) => void, failed?: () => void): void {
        const isEditorial = this.categoryId === 3;
        const filter = '&isRelated=1';

        const request = this.mediaType === 'videos'
            ? this.appService.getVideos(text, 25, 1, filter, 'true', isEditorial, this.adminFlag,
                (this.currentUser as any)?.customers_id)
            : this.appService.getImages(text, 25, 1, filter, this.adminFlag, 'true',
                isEditorial ? 'editorial' : 'creative');

        request.subscribe((data: any) => done(data?.results || []), () => failed && failed());
    }

    /** At most SIMILAR_MAX, without the media being viewed and without duplicates. */
    private setRelated(rows: any[]): void {
        const category = this.categoryId === 3 ? 'editorial' : 'creative';
        const currentId = this.images.collection === '93'
            ? (this.images.filename || '').replace('ALAM_', '')
            : (this.images.id + '');
        const seen = new Set<string>();

        this.relatedProducts = (rows || [])
            .filter((obj: any) => {
                const key = obj.collection + ':' + obj.id;
                if ((obj.id + '') === currentId || seen.has(key)) { return false; }
                seen.add(key);
                return true;
            })
            .slice(0, MediaDetailComponent.SIMILAR_MAX)
            .map((obj: any) => Object.assign(obj, { category }));
    }

    /**
     * A caption is a narrow search. Below SIMILAR_MIN, search again on the first
     * keyword (or the caption's first word) and add to the list; if that still
     * falls short, show what exists rather than padding with unrelated media.
     */
    private topUpSimilar(): void {
        if (this.relatedProducts.length >= MediaDetailComponent.SIMILAR_MIN) { return; }

        const caption = (this.images?.caption || '').trim();
        const broader = (((this.images?.tags || []) as any[])
            .filter(t => t && String(t).trim() && t !== 'No Tags Available')[0]
            || caption.split(/\s+/)[0] || '').trim();

        if (!broader || broader.toLowerCase() === caption.toLowerCase()) { return; }

        const current = this.relatedProducts;
        this.searchSimilar(broader, rows => this.setRelated((current as any[]).concat(rows)));
    }

    public usageHasDownload(usage: any): boolean {
        return !!usage?.size?.some((data: any) => typeof data.download_link === 'string' && data.download_link.trim() !== '');
    }

    public usageAllDownloadsNull(usage: any): boolean {
        return !!usage?.size?.every((data: any) => data.download_link == null || data.download_link === '');
    }

    public isUsageChecked(usage: any): boolean {
        const list = this.usageType?.usage || [];
        for (const u of list) {
            if (this.usageHasDownload(u)) {
                return u === usage;
            }
        }
        return false;
    }

    public hasTags(): boolean {
        const tags = this.images?.tags || [];
        if (!tags.length) {
            return false;
        }
        if (tags.length === 1 && tags[0] === 'No Tags Available') {
            return false;
        }
        return true;
    }

    public isModelReleased(): boolean {
        return this.images?.collection === '197'
            || this.images?.collection === '21'
            || this.images?.model === 'Yes';
    }

    public isPropertyReleased(): boolean {
        return this.images?.collection === '197'
            || this.images?.collection === '21'
            || this.images?.property === 'Yes';
    }

    checkDescription(): boolean {
        const desc = this.images?.desc || '';
        return /(^|\s|-)(ai)(\s|-|$)/i.test(desc);
        // return this.images?.desc.toLowerCase().includes('ai');
    }

    /* ---------- Layout shared with products/media-detail ---------- */

    /** Which of the three detail sections under the image are expanded. */
    public open = { details: true, licence: true, ai: true };

    public toggleSection(key: 'details' | 'licence' | 'ai'): void {
        this.open[key] = !this.open[key];
    }

    /** The exclusive collections whose every image is AI generated. */
    public get isAiCollection(): boolean {
        const c = this.images?.collection;
        return c == '223' || c == '225' || c == '222';
    }

    /** The size object behind the selected size name. */
    public get selectedSize(): any {
        return (this.images?.sizes || []).filter((s: any) => s.name === this.cartProduct?.size)[0] || null;
    }

    public get shareUrl(): string {
        return 'https://' + window.location.host + '/product/detail/' + this.mediaType + '/' + this.collection + '/' + this.id;
    }

    /** "864 X 1152" → "864 × 1152". */
    public dims(value: any): string {
        return String(value || '').replace(/\s*[xX×]\s*/g, ' × ').trim();
    }

    /** "1152 × 1152 px · 12 × 12 in @ 300 dpi · JPG"; a vector is "Scalable to any size". */
    public sizeSpec(size: any): string {
        if (!size) { return ''; }
        if (size.name === 'Vector') { return 'Scalable to any size'; }

        const parts: string[] = [];
        // The API's dpi sometimes already ends in "dpi"; strip it so it is not printed twice.
        const dpi = String(size.dpi || '').replace(/\s*dpi\s*$/i, '').trim();

        if (size.pixels) { parts.push(this.dims(size.pixels) + ' px'); }
        if (this.mediaType === 'images' && size.inches) {
            parts.push(this.dims(size.inches) + ' in' + (dpi ? ' @ ' + dpi + ' dpi' : ''));
        }

        const ext = size.ext || (this.images?.filename || '').split('.').pop();
        if (ext && ext !== this.images?.filename) { parts.push(String(ext).toUpperCase()); }

        return parts.join(' · ');
    }

    /** The image the "Edit with AI" modal is open on; null while it is closed. */
    public aiEditSource: AiEditSource | null = null;

    public editWithAi(event: Event): void {
        event.preventDefault();
        this.aiEditSource = {
            id: this.images?.id,
            filename: this.images?.filename,
            caption: this.images?.caption,
            thumbnail: this.images?.thumbnail,
            size: this.selectedSize?.pixels ? this.dims(this.selectedSize.pixels) : '',
            source: 'image-detail'
        };
    }
}
